<template>
  <div id="app">
    <SpotifyConverter />
  </div>
</template>

<script>
import SpotifyConverter from './components/SpotifyConverter.vue'

export default {
  name: 'App',
  components: {
    SpotifyConverter
  }
}
</script>
